import React from 'react';
import { CalendarCellProps } from '@progress/kendo-react-dateinputs';
import { classNames } from '@progress/kendo-react-common';

interface BookingCalendarCellProps extends CalendarCellProps {
  availableDates?: Date[];
}

export const BookingCalendarCell: React.FC<BookingCalendarCellProps> = (props) => {

  const isAvailableDate = (date: Date): boolean => {
    return props.availableDates?.some((availableDate) => {
      const formattedAvailableDate = new Date(availableDate).toISOString().split('T')[0];
      const formattedDate = date.toISOString().split('T')[0];
       return (
        formattedAvailableDate === formattedDate
      );
    }) ?? true;
  };

  const isDisabled = !isAvailableDate(props.value);

  const handleClick = (e: React.MouseEvent<HTMLTableCellElement>) => {
    if (!isDisabled) {
      if (props.onClick) {
        props.onClick(props.value, e);
      }
    }
  };

  const style = {
    cursor: 'pointer',
    opacity: isDisabled ? 0.2 : 1,
    textDecoration: isDisabled ? 'line-through' : 'none',
  };

  const {
    className,
    formattedValue,
    isFocused,
    isInRange,
    isSelected,
    isRangeStart,
    isRangeMid,
    isRangeEnd,
    isRangeSplitStart,
    isRangeSplitEnd,
    isToday,
    view,
    value,
    isWeekend,
    isOtherMonth,
    isDisabled: _isDisabled,
    showOtherMonthDays,
    allowReverse,
    availableDates,
    ...other
  } = props;

  const isEndActive = props.activeRangeEnd === 'end' && isRangeEnd;
  const isStartActive = props.activeRangeEnd === 'start' && isRangeStart;

  const rootClassName = classNames(
    'k-calendar-td',
    {
      'k-range-end': isRangeEnd,
      'k-range-mid': isRangeMid,
      'k-range-split-end': isRangeSplitEnd,
      'k-range-split-start': isRangeSplitStart,
      'k-range-start': isRangeStart,
      'k-active': isStartActive || isEndActive,
      'k-state-pending-focus': isFocused,
      'k-selected': isSelected || isRangeStart || isRangeEnd,
      'k-today': isToday,
      'k-disabled': isDisabled,
    },
    className
  );


  return (
    <td
      {...other} // only valid DOM props will be spread
      className={rootClassName}
      onClick={handleClick}
      onMouseEnter={props.handleMouseEnter}
      onMouseLeave={props.handleMouseLeave}
      style={style}
    >
      <span className="k-link">
        {props.children}
      </span>
    </td>
  );
};

export default BookingCalendarCell;
